import React from 'react';
import clsx from 'clsx';
// @ts-ignore
import styles from './MatchConfirmation.module.scss?module';

type MatchConfirmationProps = {
  confirmed: boolean;
  onConfirmedChange: (confirmed: boolean) => void;
};

/**
 * Mandatory confirmation whenever the assortment check found something (P-4972,
 * Malte 14.09.). It sits inside the hint, directly under the suggestions it
 * refers to - next to the email consent checkbox both boxes would be ticked in
 * one go and the customer would never read the suggestions.
 */
const MatchConfirmation = ({
  confirmed,
  onConfirmedChange,
}: MatchConfirmationProps) => (
  <div className={clsx('form-check', styles.confirmation)}>
    <input
      className="form-check-input"
      type="checkbox"
      id="listingRequestMatchConfirmed"
      checked={confirmed}
      onChange={(event) => onConfirmedChange(event.currentTarget.checked)}
    />
    <label className="form-check-label" htmlFor="listingRequestMatchConfirmed">
      None of the products shown above is the one I am looking for.*
    </label>
  </div>
);

export default MatchConfirmation;
